import { render, staticRenderFns } from "./About.vue?vue&type=template&id=615155a1&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "../../../public/assets/css/general-front-css.css?vue&type=style&index=0&id=615155a1&scoped=true&lang=css&"
import style1 from "./About.vue?vue&type=style&index=1&id=615155a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615155a1",
  null
  
)

export default component.exports